import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Mail, MapPin, Phone } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks — we've received your message.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 grid md:grid-cols-12 gap-14">
      <div className="md:col-span-5">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Contact Us</span>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-6">Let's talk frequencies.</h1>
        <p className="text-muted-foreground leading-relaxed mb-10">Questions about scans, memberships or workshops? Send a note and our team will get back to you.</p>
        <div className="space-y-5">
          <div className="flex items-center gap-4"><span className="grid place-items-center h-11 w-11 rounded-full bg-primary/15 text-primary"><Mail size={18} strokeWidth={1.5} /></span><span className="text-sm text-secondary-foreground">admin@voicematrix.in</span></div>
          <div className="flex items-center gap-4"><span className="grid place-items-center h-11 w-11 rounded-full bg-primary/15 text-primary"><Phone size={18} strokeWidth={1.5} /></span><span className="text-sm text-secondary-foreground">+91 86680 98794</span></div>
          <div className="flex items-center gap-4"><span className="grid place-items-center h-11 w-11 rounded-full bg-primary/15 text-primary"><MapPin size={18} strokeWidth={1.5} /></span><span className="text-sm text-secondary-foreground">Chandigarh-U.T, India</span></div>
        </div>
      </div>
      <div className="md:col-span-7">
        <form onSubmit={submit} className="rounded-2xl border border-border bg-card p-8 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div className="space-y-2"><Label htmlFor="name">Name</Label><Input id="name" required value={form.name} onChange={set("name")} data-testid="contact-name-input" className="bg-secondary border-border" /></div>
            <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={form.email} onChange={set("email")} data-testid="contact-email-input" className="bg-secondary border-border" /></div>
          </div>
          <div className="space-y-2"><Label htmlFor="subject">Subject</Label><Input id="subject" required value={form.subject} onChange={set("subject")} data-testid="contact-subject-input" className="bg-secondary border-border" /></div>
          <div className="space-y-2"><Label htmlFor="message">Message</Label><Textarea id="message" required rows={5} value={form.message} onChange={set("message")} data-testid="contact-message-input" className="bg-secondary border-border" /></div>
          <Button type="submit" disabled={loading} className="rounded-full bg-primary text-primary-foreground hover:bg-primary/85 font-semibold" data-testid="contact-submit-btn">
            {loading && <Loader2 size={16} className="animate-spin" />} Send message
          </Button>
        </form>
      </div>
    </div>
  );
}
